<template>
  <div class="filters-box-row">
	<div class="filters-container" :style="collapse ? 'height: 60px' : ''">
		<div class="input-box">
			<span>员工名称：</span>
			<el-input
				v-model="staffName"
				placeholder="请输入员工名称"
				class="filter-input"
				size="mini"
				@keyup.enter.native="search"
			></el-input>
		</div>
		<div class="input-box">
			<span>员工手机号：</span>
			<el-input
				v-model="tel"
				placeholder="请输入员工手机号"
				class="filter-input"
				size="mini"
				@keyup.enter.native="search"
			></el-input>
		</div>
		<div class="input-box">
			<span>员工状态：</span>
			<el-select v-model="staffDisabled" class="filter-input" size='mini'>
				<el-option :value="0" label="全部"></el-option>
				<el-option :value="1" label="启用"></el-option>
				<el-option :value="2" label="停用"></el-option>
			</el-select>
		</div>
		<div class="input-box">
			<span>员工类型：</span>
			<el-select v-model="usertype" class="filter-input" size='mini'>
				<el-option :value="-1" label="全部"></el-option>
				<el-option :value="0" label="内控"></el-option>
				<el-option :value="1" label="业务"></el-option>
			</el-select>
		</div>
		<div class="input-box" style="width: 350px">
			<span>是否接收消息：</span>
			<el-select v-model="subscriptionSendFlag" class="filter-input" size='mini'>
				<el-option value="" label="全部"></el-option>
				<el-option :value="true" label="是"></el-option>
				<el-option :value="false" label="否"></el-option>
			</el-select>
		</div>
	</div>
	<div class="search-right-wrap">
		<el-button size="small" type="text" class="btn" @click="handleCollapse">
			{{ collapse ? '展开' : '收起' }}
			<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"/>
		</el-button>
		<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
		<el-button size="small" plain class="btn fx-btn" @click="clear">清空</el-button>
	</div>
  </div>
</template>

<script>
export default {
	name: 'search',
	props: {
		sessionStoreId: String
	},
	data () {
		return {
			staffName: '',
			staffDisabled: 0,
			usertype: -1,
			tel: '',
			subscriptionSendFlag: '',
			collapse: false
		}
	},
	methods: {
		search () {
			let params = {
				type: 0,
				sIds: [this.sessionStoreId],
				staffName: this.staffName,
				staffDisabled: this.staffDisabled,
				subscriptionSendFlag: this.subscriptionSendFlag,
				tel: this.tel,
				usertype: this.usertype,
				page: 1,
				size: 20
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/staff/list`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.$emit('getTableData', res.data)
					this.$emit('getParamsData', params)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		clear () {
			this.staffName = ''
			this.tel = ''
			this.usertype = -1
			this.staffDisabled = 0
			this.subscriptionSendFlag = ''
			this.search()
		},
		handleCollapse () {
			this.collapse = !this.collapse
		}
	}
}
</script>

<style lang="stylus" scoped>
.filters-box-row {
	border-bottom :1px solid #DCE2FD
	display: flex;
	text-align :left
	justify-content: space-between
	width :100%;
	line-height :60px;
	min-width :600px;
	box-sizing: border-box
	.filters-container {
		display flex
		flex: 1
		flex-wrap: wrap;
		overflow: hidden
		.input-box {
			display flex
			margin-left: 20px
			&>span {
				display: inline-block;
				text-align: right;
				width: 85px;
				margin-right: 5px
			}
			.filter-input {
				width: 170px
			}
		}
		.btn {
			height: 32px
			margin-top: 14px
			margin-left 20px
		}
	}
	.search-right-wrap {
		width: 200px;
		flex-shrink: 0;
		line-height: 50px
	}
}
</style>
